

import {useState, useEffect, useCallback} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './index.scss';
import ComHeader from '@/components/comHeader';
import ComTag from '@/components/comTag';
import Rate from './rate';
import Meth from './meth';
import Fare from './fare';
import ComVoid from '@/components/comVoid'
import { setTopBar, setShare } from '@/utils/jrSdk'
import { homeReqBase, homeReward, homeRecTask, alertShow, recIsBai } from '@/store/actions'
import { GetRequest } from '@/utils';
//import 
// function Home() {
//   const [num, setNum] = useState(1);
//   const dispatch = useDispatch();
//   function toNums() {
//     setNum(num + 1)
//   }
//   const { name } = useSelector(state => state.home);
//   function toPal() {
//     dispatch({type: 'PAS'});
//   }
//   return (
//     <div> 
//       <div onClick={() => dispatch({type: 'PAS'})}>{name}</div>
//       <div onClick={() => toNums()}>{num}</div>
//     </div>
//   )
// }

function Home() {
    const { config, info } = useSelector(state => state.home);
    const { task, fare } = config;
    const { isBai ,btUrl, rewardUrl, moneyUrl }  = useSelector(state => state.base);
    const [channelCode, setChannelCode] = useState(GetRequest('channelCode'));
    const [taskCode, setTaskCode] = useState(GetRequest('taskCode'));
    
    const dispatch = useDispatch();
    useEffect(() => {
        
        dispatch(homeReqBase({ channelCode: channelCode, taskCode: taskCode , pageId: '3684' }));
        dispatch(recIsBai());      
    }, [])
    useEffect(() => {
        setTopBar({title: config.headTitle || '打白条笔笔攒', bg: '#004CF1'});
        setShare(config.share);     
    }, [config])
    function toCost() {
        window.locationTo({
            url: '/cost',
            params: {
                channelCode,
                taskCode
            }
        })
    }
    function toPast() {
        window.locationTo({
            url: '/past',
            params: {
                channelCode,
                parentTaskCode: info.parentTaskCode
            }
        })
    }
    
    function toHandleBtn() {
        const btText = {
            title: '需要开通白条才能参加活动哦~',
            btnText: '我知道了',
            action: () => window.locationTo({ url: btUrl })
        }
        switch(info.realStatus) {
            //去看看其他活动
            case 'no':
            case 'fr0':
            case 'rw0':
            case 'ou0':
                window.locationTo({
                    url: '/list',
                    params: {
                        channelCode
                    }
                });
                return ;
            //领奖
            case 'ac0': {
                if(isBai) dispatch(homeRecTask({ channelCode: channelCode, taskCode: info.taskCode }));
                else dispatch(alertShow(btText))
            }break;
            //去攒更多金额
            case 'ac1':
                window.locationTo({
                    url: info.targetUrl || moneyUrl
                });
                break;
            //领取奖励
            case 'rw2': {
                if(isBai) dispatch(homeReward({ channelCode: channelCode, taskCode: taskCode }));
                else dispatch(alertShow(btText))
            };break;
            //查看奖励
            case 'rw4': 
                window.locationTo({
                    url: info.rewardDetailUrl || rewardUrl
                });
                break;
            
        }
    }
    function toTask() {
        window.locationTo({
            url: '/list',
            params: {
                channelCode: channelCode
            }
        })
    }
    return (
        <div className='home'>
            <ComHeader info={config} ruleCls='rwxqy|rule'/>
            <div className='home-panel'>
                { 
                    info.taskCycle === 3?
                    <div 
                        className='home-panel-past' 
                        onClick={toPast}
                        clstag = 'rwxqy|wqrw'
                        data-qidian-ext={JSON.stringify({missionid: info.taskCode})}
                    >往期任务</div>: 
                    null
                }
                <div className='home-panel-date'>{ info.titleTimeText }</div>
                <div className='home-panel-box'>
                    {
                    info.homeBack?
                        <ComVoid text={info.homeBackText}></ComVoid>:
                        info.rewardName? <Rate info={info}></Rate>: null
                    }
                </div>
                <div 
                    className='home-panel-btn' 
                    onClick={toHandleBtn}
                    clstag = {info.homeBtnCls}
                    data-qidian-ext={JSON.stringify({missionid: info.taskCode})}
                >
                    { info.homeBtnText }
                </div>
                <div className='home-panel-ext'>
                    <div
                        clstag = 'rwxqy|xfjl'
                        data-qidian-ext={JSON.stringify({missionid: info.taskCode})}
                        onClick={toCost}
                    >消费记录</div>
                    <i></i>
                    <div 
                        onClick={toTask}
                        clstag = 'rwxqy|gdrw'
                        data-qidian-ext={JSON.stringify({missionid: info.taskCode})}
                    >更多任务</div>
                </div>
            </div>
            {task.length? <Meth info={task} />: null}
            {fare.length? <Fare info={fare} />: null}
            <ComTag title='京东金融'></ComTag>
        </div>
    )
}
export default Home;